import { action } from 'satcheljs';
import { TimePanelSource } from '../TimePanelSource';

export const openTimePanel = action('openTimePanel', (source: TimePanelSource) => ({ source }));

export const popView = action('popView');
